export default __webpack_public_path__ + "static/media/mute_user.bdb3f2c3.svg";